/**
 * Created by portiz on 8/15/2018.
 */
import React from 'react';
import ApiCalls from '../../custom-classes/api-calls';
import { Row, Col, Button} from 'reactstrap';

/** Multiple Language imports **/
import { withLocalize } from "react-localize-redux";
import { renderToStaticMarkup } from 'react-dom/server'; // Fix by the author. Do not remove even if it's not resolved
import { Translate } from "react-localize-redux";
import global from "../../translations/global.json";
/** End of Multiple Language imports **/
import LanguageManager from '../../custom-classes/language-manager';

import FormGroupUsername from '../forms/form-group-username';
import FormGroupEmail from '../forms/form-group-email';
import FormGroupNewPassword from '../forms/form-group-new-password';
import FormGroupAddress from '../forms/form-group-address';
import FormGroupName from '../forms/form-group-name';
import FormGroupPhone from '../forms/form-group-phone';
import ModalGeneric from '../modals/modal-generic';
import LoaderFullWindow from '../loader-windows/loader-full-window';
import ModalClients from '../modals/modal-clients';
import Settings from '../../custom-classes/settings';

/**
 * The form to register the client by the admin
 */
class FormRegistrationByAdmin extends React.Component{

    constructor(props){
        // Super is always called when defining the constructor of a subclass
        // All React component classes that have a constructor, should start it with a super(props) call.
        super(props);
        // To support language library add the following lines
        this.props.initialize({
            languages: [
                { name: "English", code: "en" },
                { name: "Español", code: "es" }
            ],
            options: { renderToStaticMarkup, defaultLanguage: LanguageManager.getLanguage() }
        });
        this.props.addTranslation(global);


        this.state = {
            mobile: false,
            firstName: '',
            lastName: '',
            password: '',
            passwordRetype: '',
            username: '',
            email: '',
            phone: '',
            addressLine1: '',
            addressLine2: '',
            city: '',
            state: '',
            country: '',
            zipCode: '',
            validPassword: false,
            validEmail: false,
            usernameAvailable: true,
            validUsername: false,
            validFirstName: false,
            validLastName: false,
            validPhone: false,
            validAddress: false,
            validCity: false,
            validState: false,
            validCountry: false,
            validZipCode: false,
            proceedToInsert: false, // To proceed to the insertation. It evaluates if the fields are correct.
            showModal: false, // If show the generic modal
            didMount: false, // If the component did mout
            stateRequired: false, // If the state (address) is required
            successfulTransaction: true, // If the transaction was successful or not. The default is true, so we don't show any error messages at the beggining
            loading: false, // To show or hide the loading window
            propsModal: null, // The generic data for the generic modal of messages
            userId: null, // The ID of the user (created or selected)
            disabledName: false, // To disable name field
            disabledPhoneNumber: false, // To disable phone number field
            disabledUsername: false, // To disable the username field
            disabledPassword: false, // To disable the password field
            disabledEmail: false, // To Disable email field
            disabledAddress: false, // To disable address field
            showInsertionButton: true, // To hide or show the insertion button of the form
            modalClientVisible: false, // To hide or show the modal to choose clients
            showAddExistingAccountButton: true // To hide or show the existing button
        };
        this.submitRegister = this.submitRegister.bind(this);
        this.toggleAlertModal = this.toggleAlertModal.bind(this);
        this.handleClientButton = this.handleClientButton.bind(this);
        this.handleSelectedUser = this.handleSelectedUser.bind(this);

    }

    componentWillReceiveProps(props){
        if(typeof props.data.userData !== 'undefined' && props.data.userData !== null)
        {
            this.setState({
                disabledName: props.data.disabledName,
                disabledPhoneNumber: props.data.disabledPhoneNumber,
                disabledUsername: props.data.disabledUsername,
                disabledPassword: props.data.disabledPassword,
                disabledEmail: props.data.disabledEmail,
                disabledAddress: props.data.disabledAddress,
                showInsertionButton: false, // Is for read
                showAddExistingAccountButton: false,
                firstName: props.data.userData[0].FullName.GivenName,
                lastName: props.data.userData[0].FullName.Surname,
                username: props.data.userData[0].Username,
                email: props.data.userData[0].Email,
                phone:props.data.userData[0].Phone,
                addressLine1: props.data.userData[0].Address.AddressLine1,
                addressLine2:  props.data.userData[0].Address.AddressLine2,
                city:  props.data.userData[0].Address.City,
                state:  props.data.userData[0].Address.StateIsoCode,
                stateRequired: typeof props.data.userData[0].Address.StateIsoCode !== 'undefined'
                && props.data.userData[0].Address.StateIsoCode !== null,
                country: props.data.userData[0].Address.CountryIsoCode2,
                zipCode: props.data.userData[0].Address.Zip
            });
        }

        if(props.data.didMount)
        {
            this.setState({mobile: props.data.mobile});
        }
    }

    /**
     * Searchs the client and put the data in the info fillers
     */
    searchClient(){
        let apiCallUser = ApiCalls.getUsersAdvanced(this.state.userId, null, null, null, null, null, null, null,
            null, null, null, 1,1);
        apiCallUser.then((data)=>{
            this.setState({
                    firstName: data.UserInfo[0].FullName.GivenName,
                    lastName: data.UserInfo[0].FullName.Surname,
                    username: data.UserInfo[0].Username,
                    email: data.UserInfo[0].Email,
                    phone: data.UserInfo[0].Phone,
                    addressLine1: data.UserInfo[0].Address.AddressLine1,
                    addressLine2: data.UserInfo[0].Address.AddressLine2,
                    city: data.UserInfo[0].Address.City,
                    state: data.UserInfo[0].Address.StateIsoCode,
                    stateRequired: typeof data.UserInfo[0].Address.StateIsoCode !== 'undefined'
                    && data.UserInfo[0].Address.StateIsoCode !== null,
                    country: data.UserInfo[0].Address.CountryIsoCode2,
                    zipCode: data.UserInfo[0].Address.Zip,
                    disabledAddress: true,
                    disabledName: true,
                    disabledPhoneNumber: true,
                    disabledUsername: true,
                    disabledPassword: true,
                    disabledEmail: true,
                    showInsertionButton: false
            },()=>{
                this.props.updateParent(this.state);
                return this.state;
            });
        });
    }

    /**
     * Handles the selected client from the clients modal
     * @param e
     */
    handleSelectedUser(e){
        this.setState({
            modalClientVisible: false,
            userId: e !== null && e.UserId !== null ? e.UserId : null
        },()=>
        {
            if(this.state.userId !== null)
                this.searchClient();
        })
    }

    /**
     * Renders the generic modal
     * @returns {XML}
     */
    renderGenericModal(){
        return (
            <ModalGeneric data={this.state.propsModal} updateParent={this.toggleAlertModal}/>
        );
    }

    /**
     * Toggles alert modal (alert from registration)
     */
    toggleAlertModal(){
        this.setState({showModal: false});
    }

    /**
     * Submit register
     */
    submitRegister(){
        this.setState({loading:true});

        // Submits the registration
        let apiCall = ApiCalls.registerUserByAdmin(this.state.username, this.state.password, this.state.passwordRetype,
            this.state.email, this.state.firstName, this.state.lastName, this.state.phone, this.state.addressLine1,
            this.state.addressLine2,
            this.state.city, this.state.state, this.state.country, this.state.zipCode,
            this.state.country,
            Settings.CLIENT_ROLE_ID);
        apiCall.then((returned)=>{
            let propsModal = {
                bodyText: returned.Messages[0],
                visible: true
            };

            if(returned.TransactionValid) {
                if (returned.UserId !== null)
                    this.setState({
                        propsModal: propsModal,
                        disabledAddress: true,
                        disabledName: true,
                        disabledPhoneNumber: true,
                        disabledUsername: true,
                        disabledPassword: true,
                        disabledEmail: true,
                        showModal: true,
                        loading: false,
                        proceedToInsert: false,
                        showAddExistingAccountButton: false,
                        userId: returned.UserId});

            }
            this.props.updateParent(this.state);
            return this.state;
        });
    }

    /**
     * Sets if submit button is ready or not
     */
    setSubmitButtonState(){
        this.setState({proceedToInsert:(
            this.state.validUsername
            && this.state.validFirstName
            && this.state.validLastName
            && this.state.validUsername
            && this.state.validPassword
            && this.state.validEmail
            && this.state.validAddress
            && this.state.validCity
            && this.state.validCountry
            && (
                (this.state.stateRequired && this.state.validState)
                || (!this.state.stateRequired)
            )
            && this.state.validZipCode
        )});
    }


    /**
     * Saves the username state and verifies if the next button is ready
     * @param field
     */
    saveUsername = (field) => (newValue) =>{
        this.setState({'username': newValue.username, 'validUsername': newValue.validUsername, 'usernameAvailable': newValue.usernameAvailable},() =>{
            this.setSubmitButtonState();
        });
    };

    /**
     * Save the email state and verifies  if the next button is ready
     * @param field
     */
    saveEmail = (field) => (newValue) =>{
        this.setState({'email': newValue.email, 'validEmail': newValue.validEmail, 'emailAvailable': newValue.emailAvailable},() =>{
            this.setSubmitButtonState();
        });
    };

    /**
     * Save the password state and verifies if the next button is ready
     * @param field
     */
    savePassword = (field) => (newValue) =>{
        this.setState({'password': newValue.password, 'passwordRetype': newValue.passwordRetype, 'validPassword': newValue.validPassword},() =>{
            this.setSubmitButtonState();
        });
    };

    /**
     * Save the name details and verifies if the next button is ready
     * @param field
     */
    saveName = (field) => (newValue) =>{
        this.setState({'firstName': newValue.firstName, 'lastName': newValue.lastName, 'validFirstName': newValue.validFirstName, 'validLastName': newValue.validLastName},() =>{
            this.setSubmitButtonState();
        });
    };

    /**
     * Save the phone details and verifies if the next button is ready
     * @param filed
     */
    savePhone = (filed) => (newValue) =>{
        this.setState({'phone': newValue.phone, 'validPhone': newValue.validPhone},() =>{
            this.setSubmitButtonState();
        });
    };

    /**
     * Saves the address details and verifies if the next button is ready
     * @param field
     */
    saveAddress = (field) => (newValue) =>{
        this.setState(
            {
                'addressLine1': newValue.addressLine1,
                'addressLine2': newValue.addressLine2,
                'city': newValue.city,
                'country': newValue.country,
                'state': newValue.state,
                'zipCode': newValue.zipCode,
                'validAddress': newValue.validAddress,
                'validCity': newValue.validCity,
                'validCountry': newValue.validCountry,
                'validPhone': newValue.validPhone,
                'validState': newValue.validState,
                'validZipCode': newValue.validZipCode
            },() =>{
                this.setSubmitButtonState();
            });
    };

    handleClientButton(){
        this.setState({
            modalClientVisible: true
        });
    }

    /**
     * Renders the landing page
     * @returns {XML}
     */
    render()
    {
        return (
            <div>
                <Row>
                    <h2><b><Translate id="register.client-data"/></b></h2>
                </Row>
                <hr/>
                <Row>
                    <Col sm={{size: 12}}>
                        <h3>1. <Translate id="register.general-information"/></h3>
                        <small> <Translate id="register.general-information-instructions"/></small>
                        {' '}
                        {
                            this.state.showAddExistingAccountButton ?
                                <Button className="btn btn-warning" onClick={this.handleClientButton}>
                                    <Translate id="register.add-existing-account"/>
                                </Button> : null
                        }
                        <hr/>
                    </Col>
                    <Col sm={{size:12}}>
                        <FormGroupName disabled={this.state.disabledName} data={this.state} updateParent={this.saveName()}/>
                        <FormGroupPhone disabled={this.state.disabledPhoneNumber} data={this.state} updateParent={this.savePhone()}/>
                    </Col>
                </Row>
                <Row>
                    <Col sm={{size: 12}}>
                        <h3>2. <Translate id="register.account-details"/></h3>
                        <small> <Translate id="register.account-details-instructions"/></small>
                        <hr/>
                    </Col>
                    <Col sm={{size:12}}>
                        <FormGroupUsername disabled={this.state.disabledUsername} data={this.state} updateParent={this.saveUsername()}/>
                        <FormGroupNewPassword disabled={this.state.disabledPassword} data={this.state} updateParent={this.savePassword()}/>
                        <FormGroupEmail disabled={this.state.disabledEmail} data={this.state} updateParent={this.saveEmail()}/>
                    </Col>
                </Row>
                <Row>
                    <Col sm={{size: 12}}>
                        <h3>3. <Translate id="register.billing-address"/></h3>
                         <small> <Translate id="register.billing-address-instructions"/></small>
                        <hr/>
                    </Col>
                    <Col sm={{size:12}}>
                        <FormGroupAddress disabled={this.state.disabledAddress} data={this.state} updateParent={this.saveAddress()}/>
                    </Col>
                </Row>
                <hr/>
                {this.state.showInsertionButton ?
                    <Row>
                        <Col sm={{size: 8}}>
                            <h4><Translate id="register.client-data-submit-instructions"/></h4>
                        </Col>
                        <Col sm={{size:4}}>
                            <Button onClick={this.submitRegister} color="success" block disabled={!this.state.proceedToInsert}>
                                <Translate id="general.submit"/>
                            </Button>
                        </Col>
                    </Row>: null
                }
                <div>
                    {this.state.loading ? <LoaderFullWindow/> : null}
                    {this.state.showModal ? this.renderGenericModal() : null}
                    {this.state.modalClientVisible ? <ModalClients visible={this.state.modalClientVisible}
                                                                   updateParent={this.handleSelectedUser} /> : null}
                </div>
            </div>
        )
    };
}

export default withLocalize(FormRegistrationByAdmin);